import { useEffect, useState } from 'react'
import { Box, DialogContent, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material'
import MUIDialog from '@mui/material/Dialog'
import { t } from 'i18next'
import { useSelector } from 'react-redux'

import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import {
  SelectUserDialogStyles as styles,
  useStyles
} from 'src/components/shared/ui/SelectUserDialog/SelectUserDialogStyles'
import RequiredText from 'src/components/views/EscritosLexnet/components/shared/components/RequiredText'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { userSelector } from 'src/state/authentication/selectors'
import { User } from 'src/state/authentication/types'

import ButtonSecondary from '../ButtonSecondary'
import DialogTitle from '../DialogTitle/DialogTitle'
import { AngleDownIcon2 } from '../Icons'

type Props = {
  show: boolean
  close: () => void
  select: (user: any) => void
  disabledButton: boolean
}

export default function SelectUserDialog({
  show,
  close,
  disabledButton,
  select
}: Props): JSX.Element {
  const user = useSelector(userSelector)
  const { getUsers: getCurrentUsers, getLexnetUserText } = useLexnetStatusContext()
  const [userId, setUserId] = useState<any>(0)
  const classes = useStyles()
  const [users, setUsers] = useState<User[]>([])

  function onClose() {
    close()
  }

  function onSelect() {
    const { users } = getCurrentUsers()
    const user = users.find((user: User) => user.id === userId)
    select(user)
  }

  // function getUsers() {
  //   const { users } = getCurrentUsers()

  //   if (!users || !users.length) {
  //     return []
  //   }

  //   if (userId === 0 || userId === undefined) {
  //     const selectedUser = users.find(u => u.selected === 1)

  //     let selectedId = users[0].id

  //     if (selectedUser) {
  //       selectedId = selectedUser.id
  //     }

  //     setUserId(selectedId)
  //   }
  // }

  function onSelectChange(event: SelectChangeEvent): void {
    setUserId(Number(event.target.value))
  }

  useEffect(() => {
    const { users } = getCurrentUsers()

    if (users.length > 0) {
      const selectedUser = users.find((userC: User) => userC.id === user?.id)

      if (selectedUser) {
        setUserId(selectedUser.id)
      } else {
        setUserId(users[0].id)
      }
    }

    setUsers(users)

    // eslint-disable-next-line
  }, [])

  return (
    <MUIDialog open={show} fullWidth maxWidth="md" fullScreen={false}>
      <DialogTitle id="dialog-user"> {t('dialog.title.user_selection')}</DialogTitle>
      <DialogContent sx={styles.content}>
        <RequiredText />
        <Box className="radio-wrapper">
          <InputLabel id="select-user-profile-label" required>
            {t('components.connection_chips.profile')}
          </InputLabel>
          <Select
            labelId="select-user-profile-label"
            id="select-user-profile"
            value={userId}
            onChange={onSelectChange}
            sx={styles.selectProfile}
            variant="outlined"
            MenuProps={{
              PaperProps: {
                className: classes.popper
              }
            }}
            IconComponent={_props => (
              <Box className="wrapperIcon">
                <AngleDownIcon2 className={_props.className.toString()} />
              </Box>
            )}
          >
            {users.map(user => (
              <MenuItem key={user.id} value={user.id} sx={styles.option}>
                {getLexnetUserText(user)}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </DialogContent>
      <Box sx={styles.sendButton}>
        <ButtonPrimaryOutlined onClick={onClose}>{t('actions.cancel')}</ButtonPrimaryOutlined>
        <ButtonSecondary disabled={disabledButton} onClick={onSelect}>
          {t('actions.save')}
        </ButtonSecondary>
      </Box>
    </MUIDialog>
  )
}
